export type DefaultPublishAction = 'post_now' | 'schedule_publish';

function isSameDay(a: Date, b: Date): boolean {
  return (
    a.getFullYear() === b.getFullYear() &&
    a.getMonth() === b.getMonth() &&
    a.getDate() === b.getDate()
  );
}

export function defaultPublishAction(
  post: { status?: string | null; scheduled_at?: string | null } | null | undefined,
  now: Date = new Date(),
): DefaultPublishAction {
  if (!post || post.status !== 'draft' || !post.scheduled_at) return 'post_now';
  const planned = new Date(post.scheduled_at);
  if (Number.isNaN(planned.getTime())) return 'post_now';
  return isSameDay(planned, now) ? 'post_now' : 'schedule_publish';
}
